module.exports = __webpack_public_path__ + "img/16.c625c3ec.jpg";